<template>
    <div class="singleChoseTree">
      <!-- v-if="defaultLabel" -->
      <el-tree
        class="unSchTree"
        ref="tree"
        :data="treeData"
        node-key="title_code"
        show-checkbox
        :check-strictly="true"
        :props="defaultProps"
        :default-checked-keys="defaultLabel"
        :default-expanded-keys="defaultLabel"
        @node-click="handleNodeClick"
        @check-change="handleCheckChange"
        @node-expand="handleNodeExpand"
        style="width:100%;">
      </el-tree>
    </div>
</template>
<script>
// 单选树形图组件，单选，只有最后一级显示复选框
//数据要求，只要是非最后一级的节点，数据要加上disabled: true，第一级可以不加
import $ from 'jquery';
import magic from "@/../static/common/magic.js";
export default {
    props: ["treeData","checked"], //组件接受参数
    watch:{
      checked:{
        handler(val, oldVal){
          let _this = this;
          
          if(val.data.length > 0){
            _this.countArr = [];
            for(let i=0;i<val.data.length;i++){
              if(val.data[i]){
                _this.countArr.push(val.data[i].title_code);
              }
            }
            _this.defaultLabel = val.data;
            _this.$refs.tree.setCheckedKeys(_this.countArr);
          }
        },
        deep:true //true 深度监听
      }
    },
    components: {},
    data() {
      return {
        data: [{
            id: 1,
            label: '一级 1',
            children: [{
                id: 4,
                label: '二级 1-1',
                disabled: true,   
                children: [{
                id: 9,
                label: '三级 1-1-1'
            }, {
                id: 10,
                label: '三级 1-1-2'
            }]
        }]
        }, {
            id: 2,
            label: '一级 2',
            children: [{
                id: 5,
                label: '二级 2-1'
            }, {
                id: 6,
                label: '二级 2-2'
            }]
        }, {
            id: 3,
            label: '一级 3',
            children: [{
                id: 7,
                label: '二级 3-1'
            }, {
                id: 8,
                label: '二级 3-2'
            }]
        }],
        defaultProps: {
          children: 'childrenList',
          label: 'title_name'
        },
        defaultLabel: [],
        countArr: [],//计算树被选中的个数
        emitArr: []//需要传到父级组件的当选数组
      };
    },
    methods: {
      //树形图点击展开事件
      handleNodeExpand(data,node,self){
          setTimeout(() => {$('.unSchTree .is-disabled').css('display','none');}, 0);
      },
      //树形图点击选中复选框事件
      handleCheckChange(data, checked, node){
        let _this = this;

        if(!data.childrenList.length){
          
          for(let i=0;i<_this.treeData.length;i++){
            for(let j=0;j<_this.treeData[i].childrenList.length;j++){
              if(_this.treeData[i].childrenList[j].title_name == data.title_name){
                
                if (checked == true) {//点击未选选项是触发
                  
                  _this.countArr[i] = data.title_code;
                  _this.emitArr[i] = data;
                  
                  _this.$refs.tree.setCheckedKeys(_this.countArr);
                  _this.$emit('treeCurrentCheckedData', _this.emitArr);//返回当前选中数据
                }else {
                  
                  if (_this.countArr[i] == data.title_code) {
                    
                    _this.$refs.tree.setCheckedKeys(_this.countArr);
                    _this.$emit('treeCurrentCheckedData', _this.emitArr);//返回当前选中数据
                  }
                }
              }
            }
          }
        }

      },
      //树形图点击文字事件
      handleNodeClick(data,checked,node) {     
          let _this = this;       
          
          magic.loginOrRights(2).then(res => {
              if (!res) {
                  _this.$message.error("请您登录！");
                  return;
              }
              if (res && res.rights == 0) {
                  _this.$message.error("您没有权限！");
                  return;
              }

              if(!data.childrenList.length){

                for(let i=0;i<_this.treeData.length;i++){
                  for(let j=0;j<_this.treeData[i].childrenList.length;j++){

                    if(_this.treeData[i].childrenList[j].title_name == data.title_name){

                      _this.countArr[i] = data.title_code;
                      _this.emitArr[i] = data;
                      _this.$refs.tree.setCheckedKeys(_this.countArr);
                      _this.$emit('treeCurrentCheckedData', _this.emitArr);//返回当前选中数据
                    }
                  }
                }
              }
              
              // 埋点
              try {
                  //LogCollection.contents["key"]="value";
                  //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
                  //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
                  LogCollection.send(9);
              } catch (e) {}
          });
      },
      //获取第一个子集node来做默认选中态
      getfirstNode(val){
        let data = val[0];
        
        if(data.childrenList.length > 0){
          this.getfirstNode(data.childrenList);
        }else{
          this.defaultLabel = [data.title_code];
          this.countArr[0] = data.title_code;
          this.emitArr[0] = {title_code: data.title_code, title_name: data.title_name};
        }
      }
    },
    beforeMount () {
      
    },
    mounted() {
      let _this = this;
      $('.el-tree .el-checkbox').css('display','none');
      this.getfirstNode(this.treeData);

      if(this.treeData.length > 0){//每一根节点可以只单选一个
        for(let i=0;i<_this.treeData.length-1;i++){
          _this.countArr.push('');
          _this.emitArr.push('');
        }
        // console.log(_this.emitArr,'_this.emitArr')
      }

    }
};
</script>
<style scoped lang="less">
.singleChoseTree{
    width:100%;
    height:100%;
}
</style>


// WEBPACK FOOTER //
// src/components/singleChoseTree.vue